export const defaultStyle = {
    NewsDetWrpr:"flex flex-wrap md:px-[15px] md:pb-[75px] px-[35px] pb-[45px] newsDetailWrapper xl:max-w-xl xl:w-full md:max-w-md lg:max-w-lg mx-auto print:max-w-full ",
    LeftTextWrap:"w-[24%]  max-[991px]:w-full max-[1200px]:w-[32%]  pr-[0px] lg:pr-[40px] print:w-full",
    rightTextWrap:"w-[76%] rightDetailWrap  max-[991px]:w-full max-[1200px]:w-[68%]  pl-[0px] lg:pl-[120px]  print:w-full",
    linkContainer:"",
    linkwrap:'',
    linkDown:"flex bg-[url(../images/green-wave-shape.png)] py-[40px] items-center  justify-center text-white uppercase md:text-[21px] text-[16px] tracking-[4.2px] after:content-[''] after:bg-[url(../images/white-arrow.svg)] after:bg-contain after:ml-[5px] after:bg-no-repeat after:w-[20px] after:h-[20px] after:flex ",
}

export const COL_WIDTH_6 = {
    ...defaultStyle,
    NewsDetWrpr:"flex flex-wrap md:px-[15px] lg:px-0 py-[30px] lg:py-[50px] xl:max-w-xl xl:w-full md:max-w-md lg:max-w-lg mx-auto ",
    LeftTextWrap:"w-1/2 xl:pr-[40px] max-[991px]:w-full pr-[0px] lg:pr-[15px] pb-[30px] lg:pb-0",
    rightTextWrap:"w-1/2 rightDetailWrap max-[991px]:w-full px-[35px] md:px-0",
}
export const COL_WIDTH__6_WITHOUT_SPACE={
    ...defaultStyle,
    NewsDetWrpr:"flex flex-wrap md:px-[15px] lg:px-0  xl:max-w-xl xl:w-full md:max-w-md lg:max-w-lg mx-auto ",
    LeftTextWrap:"w-1/2 xl:pr-[40px] max-[991px]:w-full pr-[0px] lg:pr-[15px] pb-[30px] lg:pb-0",
    rightTextWrap:"w-1/2 rightDetailWrap max-[991px]:w-full px-[35px] md:px-0",
}
export const SNACKIG_RIGHT_IMAGE_WITH_TEXT={
    NewsDetWrpr:"flex flex-wrap px-[20px] lg:max-w-lg xl:max-w-[1050px] xl:px-0 mx-auto flex-col-reverse lg:flex-row-reverse relative mb-[115px] xl:mb-70 lg:mt-[-70px]",
    LeftTextWrap:"lg:w-[24.5%]",
    rightTextWrap:"lg:w-[75.5%] mb-[48px] lg:mb-0 lg:pr-[48px] xl:pr-0 flex justify-center",
    linkContainer: "pb-40 z-100 relative",
    linkwrap: "text-center",
    linkDown: "bg-Bisque text-[18px] leading-[27px] font-BwSurcoBold py-[16px] px-[32px] inline-block mx-auto rounded-full hover:bg-[#D4B7EC] transition delay-100 duration-300 ease-in-out"
}
